import PropTypes from 'prop-types';
import BackgroundDots from "../../images/header-dots.png"
import {GoArrowRight} from "react-icons/go";

const HeaderCard = ({children, className, onBack, hasBack}) => {
    return <div className={`${className} t-header-card`}>
        {hasBack && <GoArrowRight onClick={onBack} className="back-button"/>}
        <img className="w-full absolute  -left-1/2 z-10" src={BackgroundDots} alt=""/>
                {children}
           </div>
}
HeaderCard.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    hasBack: PropTypes.bool,
    onBack: PropTypes.func,


}
HeaderCard.defaultProps = {
    className: "",
    children: "",
    hasBack: false,
    onBack: () => {

    }
}
export default HeaderCard;